$(document).on('click', '.header__toggle', function () {
  const isModalActive = $('.modal.active').length !== 0;
  isModalActive ? $('.modal').removeClass('active') : $('.collapse').toggleClass('active');
  $('html').toggleClass('no-scroll');
});

$(document).keydown(function (e) {
  if (e.keyCode == 27 && $('.collapse.active').length !== 0) {
    $('.collapse').removeClass('active');
    $('html').removeClass('no-scroll');
  }
});

$(document).on('click', function (e) {
  const isDropdownClicked = $(e.target).closest('header .nav-item.dropdown, .collapse .nav-item.dropdown').length !== 0;
  if (!isDropdownClicked) {
    $('.header .dropdown-menu, .header .dropdown-menu-toggler, .collapse .dropdown-menu, .collapse .dropdown-menu-toggler').removeClass('active');
    $('.dropdown-menu').hide();
  }
});

function hideCollapse() {
  if ($('.collapse.active').length !== 0 && $(window).width() >= 1200) {
    $('.collapse').removeClass('active');
    $('html').toggleClass('no-scroll');
  }
}

$(window).resize(hideCollapse);
